// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Faq_wrapper__HFarg","title":"Faq_title__VmT_u","item":"Faq_item__hPfz1","question":"Faq_question__K2UP8"};